import type { CollectionItem } from '@/lib/blocks/collection/blocks';

export function isCollectionItemLike(item: unknown): item is CollectionItem {
  return (
    item !== null &&
    typeof item === 'object' &&
    !Array.isArray(item) &&
    typeof (item as { id?: unknown }).id === 'string'
  );
}

export function readCollectionItems(value: unknown): CollectionItem[] {
  if (!Array.isArray(value)) return [];
  return value.filter(isCollectionItemLike);
}
